import React, { useEffect, useState } from "react";
import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { Badge, Button, ButtonGroup } from "reactstrap";
import { Link, useNavigate } from "react-router-dom";
import { Triangle } from "react-loader-spinner";
import DeleteModal from "../../../Components/Common/DeleteModal";
import CustomDataTable from "../../../Components/CustomTable/CustomTable";
import ThemeOptionService from "../../../Services/QRCodeServices/QrThemeService/ThemeOptionService";
import toast from "react-hot-toast";

const ThemeOption = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  const fetchData = async () => {
    setLoading(true); // Start loading
    try {
      const response = await ThemeOptionService.get();
      console.log("🚀 ~ fetchData ~ response:", response);
      setData(response);
    } catch (error) {
      console.log(error);
    } finally {
      setLoading(false); // Stop loading after API call is done
    }
  };

  useEffect(() => {
    fetchData();
  }, []);
  const [deleteModal, setDeleteModal] = useState(false);

  const [selectedDeleteItem, setSelectedDeleteItem] = useState(null);
  const toggleDeleteModal = () => setDeleteModal(!deleteModal);

  const handleDeleteClick = (item) => {
    setSelectedDeleteItem(item);
    toggleDeleteModal();
  };

  const handleDelete = async () => {
    if (selectedDeleteItem) {
      try {
        await ThemeOptionService.delete(selectedDeleteItem.id);
        setData((prevList) =>
          prevList.filter((pkg) => pkg.id !== selectedDeleteItem.id)
        );
        toast.success("Selected theme deleted successfully");
      } catch (error) {
        toast.error("Failed to delete the theme");
      } finally {
        toggleDeleteModal();
        setSelectedDeleteItem(null);
      }
    }
  };

  const statusColor = {
    false: "bg-danger",
    true: "bg-success",
  };

  const columns = [
    {
      name: "S.N",
      selector: (row, index) => index + 1,
      sortable: true,
      width: "75px",
    },
  
    {
      name: "Title",
      selector: (row) => (
        <Link to={`/theme-option/detail/${row?.id}`}>{row?.title}</Link>
      ),
      sortable: true,
    },
    {
      name: "Keys count",
      selector: (row) => row?.keysCount || "N/A",
      sortable: true,
    },
    {
      name: "isDefault",
      selector: (row) => (
        <Badge className={statusColor[row?.isDefault] || ""}>
          {row?.isDefault ? "Yes" : "No"}
        </Badge>
      ),
      sortable: true,
    },

    
    {
      name: "Actions",
      cell: (row) => (
        <ButtonGroup className="gap-3">
          <Button
            color="warning"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => navigate(`/theme-option/update/${row.id}`)}
          >
            <i className="bx bx-edit"></i>
          </Button>
          <Button
            color="danger"
            className="rounded-circle btn-sm d-flex align-items-center justify-content-center"
            style={{ width: "30px", height: "30px" }}
            onClick={() => handleDeleteClick(row)}
          >
            <i className="bx bx-trash"></i>
          </Button>
        </ButtonGroup>
      ),
      center: true,
    },
  ];
  return (
    <div className="page-content">
      <div className="container-fluid">
        <BreadCrumb title="Themes Option List" pageTitle="Theme Option" />
      </div>
      <div className="d-flex justify-content-end mb-2">
        <Button onClick={() => navigate("/theme-option/create")}>
          Add Theme
        </Button>
      </div>
      <CustomDataTable
        responsive
        striped
        pagination
        fixedHeader
        persistTableHead
        progressPending={loading}
        columns={columns}
        data={data}
        customStyles={{
          headCells: {
            style: {
              fontSize: "0.93rem",
              fontWeight: 610,
            },
          },
          rows: {
            style: {
              fontSize: "0.9rem",
            },
          },
        }}
        progressComponent={
          <div className="my-3">
            <Triangle
              visible={true}
              height="80"
              width="80"
              color="#5B71B9"
              ariaLabel="triangle-loading"
              wrapperStyle={{}}
              wrapperClass=""
            />
            <h5 className="mt-1">Loading...</h5>
          </div>
        }
      />
      <DeleteModal
        show={deleteModal}
        onDeleteClick={handleDelete}
        onCloseClick={toggleDeleteModal}
        selectedItem={selectedDeleteItem} // Pass the selected item
      />
    </div>
  );
};

export default ThemeOption;
